export class PaygSummaryModel {
  totalProperties: number;
  paygproperties: number;
  paygpropertiesChange: number;
  cotLastMonth: number;
  cotThisMonth: number;
  avgConsumptionThisMonth: number;
  avgConsumptionLastMonth: number;
  avgPaymentThisMonth: number;
  avgPaymentLastMonth: number;
  creditStatusBalanceThisMonth: number;
  creditStatusBalanceLastMonth: number;
  avgPaymentTimeThisMonth: number;
  avgPaymentTimeLastMonth: number;
  websiteUsers: number;
  clientId: number;
  siteId: number;
}
